import { findTeamInPit } from "src/components/OrgChart/model/pits/orgChartChildTeams";
import type { Team } from "src/components/OrgChart/types";

type OrgChartTeam = {
  id?: string;
  [key: string]: unknown;
};

type OrgChartSelectState = {
  teamsBaseline?: Parameters<typeof findTeamInPit>[0];
  teamsDiffline?: Parameters<typeof findTeamInPit>[0];
  teams?: Record<string, OrgChartTeam | undefined>;
  currentViewTeam?: OrgChartTeam | null;
};

export const isOrgChartTeam = (
  team: OrgChartTeam | null | undefined
): team is Team =>
  typeof team === "object" && team !== null && typeof team.id === "string";

export const resolveSelectedOrgChartTeam = (
  state: OrgChartSelectState | null | undefined,
  teamId: string | null | undefined
): OrgChartTeam | null => {
  if (!teamId) {
    return state?.currentViewTeam ?? null;
  }

  const fromBaseline = findTeamInPit(state?.teamsBaseline, teamId);
  if (fromBaseline) {
    return fromBaseline;
  }

  const fromDiffline = findTeamInPit(state?.teamsDiffline, teamId);
  if (fromDiffline) {
    return fromDiffline;
  }

  // Stories / older mocks may still put teams on `state.teams`.
  if (state?.teams?.[teamId]) {
    return state.teams[teamId] ?? null;
  }

  if (state?.currentViewTeam?.id === teamId) {
    return state.currentViewTeam;
  }

  // Selected id not loaded yet — do not fall back to a different view root.
  return null;
};
